jQuery(document).ready(function($) {

  var prodURL = "hcu.org";
  var demoURL = "heartland-2021";

  // automatic speedbump
  // find all external links
  $('a:not([href=""], [href^="https://www.' + prodURL + '/"], [href^="http://' + demoURL + '.lrsws.co/"], [href^="https://www.' + prodURL + '/"], [href^="http://' + prodURL + '"], [href^="http://www.' + prodURL + '"], [href^="https://' + prodURL + '"], [href*="https://obc.itsme247.com/199/"], [href*="https://loans.itsme247.com/199/Home/Start/"], [href*="https://www.itsme247.com/199/MembershipApplication.aspx"], [href*="https://hcu.mortgagewebcenter.com/"], [href^="mailto"], [href^="tel"], [href^="/"], [href^="#"], [class*="no-speedbump"], [id*="url-link"], [id*="close-speedbump"], [class*="close-reveal-modal"], [class*="btn-search"])').addClass('external');

  // remove external class from links without href attribute
  $('a:not([href])').removeClass('external');
  $('.external').each(function () {
      if ($(this).attr("href").indexOf("javascript:WebForm_DoPostBack") >= 0) {
      $(this).removeClass('external');
    }
  });

  // add the link and title to the continue button
  $('body').on('click', 'a.external', function(e) {
    e.preventDefault();
    var url = $(this).attr('href');
    var target = $(this).attr('target');
    $('#url-link').attr('href', url).attr('target', target);
    $('#speedbump').addClass('open');
  });

  // close speedbump when clicking acknowledgment button
  $('#speedbump a#close-speedbump, #speedbump a#close-reveal-modal').click(function(e) {
    e.preventDefault();
    $('#speedbump').removeClass('open');
  });

  // close reveal if link is clicked
  $('#speedbump a:not([id*="close-speedbump"], #speedbump [id*="close-reveal-modal"])').click(function(){
    $('#speedbump').removeClass('open');
  });

});
